var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.25C3.71875 0.25 0.25 3.71875 0.25 8C0.25 12.2812 3.71875 15.75 8 15.75C12.2812 15.75 15.75 12.2812 15.75 8C15.75 3.71875 12.2812 0.25 8 0.25ZM10.8903 10.0312L10.2653 10.8125C10.2243 10.8638 10.1736 10.9065 10.1161 10.9382C10.0585 10.9698 9.99535 10.9899 9.93009 10.9971C9.86483 11.0044 9.79877 10.9987 9.7357 10.9804C9.67263 10.9622 9.61378 10.9316 9.5625 10.8906L7.46875 9.33687C7.32246 9.21975 7.20437 9.07122 7.12323 8.90229C7.04209 8.73336 6.99998 8.54834 7 8.36094V3.5C7 3.36739 7.05268 3.24021 7.14645 3.14645C7.24021 3.05268 7.36739 3 7.5 3H8.5C8.63261 3 8.75979 3.05268 8.85355 3.14645C8.94732 3.24021 9 3.36739 9 3.5V8L10.8125 9.32812C10.8638 9.36917 10.9065 9.41992 10.9382 9.47747C10.9699 9.53503 10.9899 9.59826 10.9971 9.66356C11.0043 9.72886 10.9986 9.79494 10.9803 9.85804C10.962 9.92113 10.9314 9.97998 10.8903 10.0312Z",
    fill: "#FF0990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployment);
export default __webpack_public_path__ + "static/media/employment.5e4adb99.svg";
export { ForwardRef as ReactComponent };